import React from 'react';

import "./GlobalBottom.css";

const GlobalBottom = () => (
    <div id="global-bottom"/>
);

export default GlobalBottom;
